"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "salvitelle": {
    "efdf3916": [{
      "hkey": "e249a3ab",
      "slug": "salvitelle",
      "name": "Salvitelle",
      "primary": true,
      "skipSearch": false
    }],
    "chiuse": [{
      "hkey": "e249a3ab",
      "slug": "salvitelle",
      "name": "Salvitelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8c661b0c": [{
      "hkey": "e249a3ab",
      "slug": "salvitelle",
      "name": "Salvitelle",
      "primary": true,
      "skipSearch": false
    }],
    "destra": [{
      "hkey": "e249a3ab",
      "slug": "salvitelle",
      "name": "Salvitelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0642c9b7": [{
      "hkey": "e249a3ab",
      "slug": "salvitelle",
      "name": "Salvitelle",
      "primary": true,
      "skipSearch": false
    }],
    "don-gregorio": [{
      "hkey": "e249a3ab",
      "slug": "salvitelle",
      "name": "Salvitelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "474bc0b8": [{
      "hkey": "e249a3ab",
      "slug": "salvitelle",
      "name": "Salvitelle",
      "primary": true,
      "skipSearch": false
    }],
    "fontana-di-marco": [{
      "hkey": "e249a3ab",
      "slug": "salvitelle",
      "name": "Salvitelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "38186529": [{
      "hkey": "45ae4a30",
      "slug": "fontanelle-san-giorgio",
      "name": "Fontanelle-San Giorgio",
      "primary": true,
      "skipSearch": false
    }],
    "fontanelle": [{
      "hkey": "45ae4a30",
      "slug": "fontanelle-san-giorgio",
      "name": "Fontanelle-San Giorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0c6d4388": [{
      "hkey": "45ae4a30",
      "slug": "fontanelle-san-giorgio",
      "name": "Fontanelle-San Giorgio",
      "primary": true,
      "skipSearch": false
    }],
    "san-giorgio": [{
      "hkey": "45ae4a30",
      "slug": "fontanelle-san-giorgio",
      "name": "Fontanelle-San Giorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "salvitelle"
    }],
    "08b2cbf0": [{
      "hkey": "e249a3ab",
      "slug": "salvitelle",
      "name": "Salvitelle",
      "primary": true,
      "skipSearch": false
    }],
    "san-marco": [{
      "hkey": "e249a3ab",
      "slug": "salvitelle",
      "name": "Salvitelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "79f77c9c": [{
      "hkey": "e249a3ab",
      "slug": "salvitelle",
      "name": "Salvitelle",
      "primary": true,
      "skipSearch": false
    }],
    "san-nicola": [{
      "hkey": "e249a3ab",
      "slug": "salvitelle",
      "name": "Salvitelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b0ca3012": [{
      "hkey": "e249a3ab",
      "slug": "salvitelle",
      "name": "Salvitelle",
      "primary": true,
      "skipSearch": false
    }],
    "taverna-romanzi": [{
      "hkey": "e249a3ab",
      "slug": "salvitelle",
      "name": "Salvitelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "46d8de0a": [{
      "hkey": "e249a3ab",
      "slug": "salvitelle",
      "name": "Salvitelle",
      "primary": true,
      "skipSearch": false
    }],
    "zia-domenica": [{
      "hkey": "e249a3ab",
      "slug": "salvitelle",
      "name": "Salvitelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;